import { MatchChangeLmp, IMatchChangeLmpTemplate } from "@sky-it-livedata/livedata-sports-design-system";
import { useSubscription } from "../../hooks/useSubscription";
import { graphql } from "appsync";
import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { LmpMatchChangeQuery, LmpMatchChangeSubscription } from "./types";

import transformQuery from "./transformers/query";
import transformSubscription from "./transformers/subscription";
import { useIntcmp } from "../../hooks/useIntcmp";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<LmpMatchChangeQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

const subscriptionDocument = graphql('subscription OnUpdateLmpMatchChangeByMatchId($matchId: ID!) {\n  onUpdateLmpMatchChangeByMatchId(matchId: $matchId) {\n    matchId\n    matchList {\n      id\n      link\n      status\n      date\n      away {\n        id\n        goal\n        shortName\n      }\n      home {\n        goal\n        id\n        shortName\n      }\n    }\n  }\n}');

export const getServerProps = ({
  props
}: WidgetContext<LmpMatchChangeQuery>): IMatchChangeLmpTemplate => {
  return transformQuery(props);
}

const LmpMatchChangeWidget = ({
  props,
   variables,
  ...rest
}: WidgetContext<IMatchChangeLmpTemplate>) => {
  log({ props, variables, ...rest });

  const updatedProps = useSubscription<
    IMatchChangeLmpTemplate,
    LmpMatchChangeSubscription,
    typeof subscriptionDocument
  >({
    initialData: props,
    graphQLDocument: subscriptionDocument,
    variables,
    transform: transformSubscription,
    mergeData: true,
  }) as IMatchChangeLmpTemplate;

  const intCmpEventHandler = useIntcmp();

  return (
    <div onClick={intCmpEventHandler}>
        <MatchChangeLmp {...updatedProps} />
    </div>
  );
}

export default LmpMatchChangeWidget;